import React, { Component } from 'react';
import { connect } from 'react-redux';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { selectExhibition_action } from '../../../actions/admin_module_action/exhibition_action/select_exhibition_action';
import { withRouter } from '../../../utils/withRouter';
import Loader from '../../../utils/Loader'
import { clearSessionStorage, toastError, vendorServiceActionId } from '../../../utils/constants'
import Header from '../../../common_components/Header';
import { emailValidator } from '../../../utils/Validator'
import Modal from "react-modal";
import Footerlogin from '../../../common_components/Footerlogin';
import AdminHeader from '../../../common_components/admin_module_header';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
// import { format } from 'date-fns';
import moment from "moment";
import { fill_action } from "../../../actions/fillCombo_action";


/* 
 * mapDispatchToProps
*/
// const mapDispatchToProps = dispatch => ({
//     loginAction: () => dispatch(loginAction())
// })

/* 
 * mapStateToProps
*/


// const mapStateToProps = state => {
//   return {
//     loginData: state,
//   };
// }


class SelectExhibition extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isOpen: false,
            isLoading: false,
            exhibitionDataList: [],
            isLoginAccess: false,
            pastList: [],
            nextList: [],
            historyToggle: 1
        }
        this.handleViewExhibition = this.handleViewExhibition.bind(this)
        this.getExhibitionListData = this.getExhibitionListData.bind(this)
        this.formatDateRange = this.formatDateRange.bind(this)


    }


    componentDidMount() {
        clearSessionStorage('')
        this.getExhibitionListData(this.props.location.state)
        this.setState({ isLoginAccess: JSON.parse(sessionStorage.getItem("loginDataSS")) })
        if (sessionStorage.getItem("RoleIDSS") == 7 || sessionStorage.getItem("RoleIDSS") == 17) {
            this.getFillList(vendorServiceActionId, '', '', sessionStorage.getItem("WorkOrderID"), '', '');
        }
    }

    getFillList(
        actionID,
        exhibitionID,
        moduleID,
        keyValue,
        value,
        exhRegistrationID,
    ) {
        const { } = this.state;
        this.setState({ isLoading: true });
        this.props
            .fill_action(
                actionID,
                exhibitionID,
                moduleID,
                keyValue,
                value,
                exhRegistrationID,
            )
            .then((data) => {
                if (data.error != 1) {
                    // voucher list
                    if (actionID == vendorServiceActionId) {
                        const isStallDesignVendor = data.data?.some(item => item.MainServiceID == 10)
                        console.log("isStallDesignVendor-->", isStallDesignVendor)
                        sessionStorage.setItem("isStallDesignVendor", isStallDesignVendor)
                    }
                } else {
                    this.setState({ isLoading: false });
                    toastError(data.msg);
                }
            })
            .catch((e) => {
                console.log(e);
            });
    }

    getExhibitionListData(stateData) {
        const { isLoading, isOpen, exhibitionDataList } = this.state
        return new Promise(async (resolve, reject) => {
            this.setState({ isLoading: true })
            this.props
                .selectExhibition_action()
                .then((data) => {
                    if (data.error != 1) {
                        console.log("0999", data.data)
                        var pastList = []
                        var nextList = []
                        data.data.map(item => {
                            var eventDate = moment(item.ToDate, "DD-MMM-YYYY")
                            if (eventDate.isBefore(moment(), "day")) {
                                pastList.push(item)
                            } else {
                                nextList.push(item)
                            }
                        })
                        this.setState({
                            exhibitionDataList: data.data, isLoading: false, pastList: pastList, nextList: nextList
                        })
                            ;
                        // console.log());
                        sessionStorage.setItem("sessionExhibitionID", data.data[0]['ExhibitionID'])
                        sessionStorage.setItem("exhibitionCode", data.data[0]['Code'])
                        sessionStorage.setItem("ExhibitionFromDateSS", data.data[0]['FromDate'])
                        sessionStorage.setItem("ExhibitionToDateSS", data.data[0]['ToDate'])
                        sessionStorage.setItem("ExhibitionAddressSS", data.data[0]['Address'])
                        sessionStorage.setItem("ExhibitionLogoSS", data.data[0]['Logo'])
                        sessionStorage.setItem("isDoubleStoreyExhibition", data.data[0]['isDoubleStorey'])
                        sessionStorage.setItem("isSSIcertificateExhibition", data.data[0]['isSSICertificate'])
                        sessionStorage.setItem("DoubleStoreyArea", data.data[0]['DoubleStoreyArea'])
                        sessionStorage.setItem("DoubleStoreyAreaPercentage", data.data[0]['DoubleStoreyAreaPercentage'])
                        sessionStorage.setItem("RulesAndRegulations", data.data[0]['RulesAndRegulations'])
                        sessionStorage.setItem("ExhibitionName", data.data[0]['ExhibitionName'])
                        var emailArr = data.data.length > 0 && data.data[0].ExhMailEmail != '' && data.data[0].ExhMailEmail != null ? data.data[0].ExhMailEmail.split(",") : []
                        var mobileArr = data.data.length > 0 && data.data[0].ExhMailMobile != '' && data.data[0].ExhMailMobile != null ? data.data[0].ExhMailMobile.split(",") : []
                        sessionStorage.setItem("sessionExhibitionEmail", JSON.stringify(emailArr))
                        sessionStorage.setItem("sessionExhibitionMobileNo", JSON.stringify(mobileArr))
                        const roleId = JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID
                        const roleName = JSON.parse(sessionStorage.getItem("loginDataSS")).RoleName
                        if (data.data.length == 1) {
                            console.log('roleid and role name : ', roleId, ' ', roleName);
                            if (roleId == 1 && roleName == "Exhibitor") {
                                this.props.navigate('/selectApplication')
                            } else if (roleId == 8 && roleName == "Partner") {
                                this.props.navigate('/selectApplication')
                            } else if (roleId == 3 && roleName == "Visitor") {
                                this.props.navigate('/visitordashboard')
                            } else if ((roleId == 2 && roleName == "Admin") || (roleId == 5 && roleName == "Visitor Admin") ||
                                (roleId == 6 && roleName == "Super Admin")) {
                                this.props.navigate('/dashboard')
                            } else if (roleId == 4 && roleName == "Agent") {
                                this.props.navigate('/agentdashboard')
                            } else if ((roleId == 25 && roleName == "Zone Manager")) {
                                this.props.navigate('/onsiteManager')
                            } else if ((roleId == 7 && roleName == "Vendor") || (roleId == 17 && roleName == "Stall Design Architect")) {
                                this.props.navigate('/VendorModule')
                            } else if (roleId == 15 && roleName == "Delegate") {
                                this.props.navigate('/delegateDashboard')
                            }
                        } else {
                            if (roleId == 1 && roleName == "Exhibitor") {
                                if (stateData != null && stateData != '' && stateData != undefined) {
                                    if (stateData.ExhibitionID != null && stateData.ExhibitionID != '' && stateData.ExhibitionID != undefined) {
                                        for (var i = 0; i < data.data.length; i++) {
                                            if (data.data[i].ExhibitionID == stateData.ExhibitionID) {
                                                // sessionStorage.setItem("sessionExhibitionID", stateData.ExhibitionID)
                                                sessionStorage.setItem("sessionExhibitionID", data.data[i].ExhibitionID)
                                                sessionStorage.setItem("exhibitionCode", data.data[i].Code)
                                                sessionStorage.setItem("sessionExhibitionName", data.data[i].ExhibitionName)
                                                sessionStorage.setItem("ExhibitionFromDateSS", data.data[i].FromDate)
                                                sessionStorage.setItem("ExhibitionToDateSS", data.data[i].ToDate)
                                                sessionStorage.setItem("ExhibitionAddressSS", data.data[i].Address)
                                                sessionStorage.setItem("ExhibitionLogoSS", data.data[i].Logo)
                                                sessionStorage.setItem("isDoubleStoreyExhibition", data.data[i].isDoubleStorey)
                                                sessionStorage.setItem("isSSIcertificateExhibition", data.data[i].isSSICertificate)
                                                sessionStorage.setItem("DoubleStoreyArea", data.data[i].DoubleStoreyArea)
                                                sessionStorage.setItem("DoubleStoreyAreaPercentage", data.data[i].DoubleStoreyAreaPercentage)
                                                sessionStorage.setItem("RulesAndRegulations", data.data[i].RulesAndRegulations)
                                                sessionStorage.setItem("ExhibitionName", data.data[i].ExhibitionName)
                                                var emailArr = data.data.length > 0 && data.data[i].ExhMailEmail != '' && data.data[i].ExhMailEmail != null ? data.data[i].ExhMailEmail.split(",") : []
                                                var mobileArr = data.data.length > 0 && data.data[i].ExhMailMobile != '' && data.data[i].ExhMailMobile != null ? data.data[i].ExhMailMobile.split(",") : []
                                                sessionStorage.setItem("sessionExhibitionEmail", JSON.stringify(emailArr))
                                                sessionStorage.setItem("sessionExhibitionMobileNo", JSON.stringify(mobileArr))
                                                const loginDataSS = JSON.parse(sessionStorage.getItem("loginDataSS"))
                                                loginDataSS.RoleID = roleId
                                                loginDataSS.RoleName = roleName
                                                sessionStorage.setItem("loginDataSS", JSON.stringify(loginDataSS))
                                                sessionStorage.setItem("RoleIDSS", loginDataSS.RoleID)
                                                this.props.navigate('/selectApplication')
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        setTimeout(() => {
                            this.setState({ isLoading: false })
                        }, 500);
                    }
                    else {
                        this.setState({ isLoading: false })
                        toastError(data.msg)
                    }
                })
                .catch((e) => {
                    console.log(e);
                });
        })
    }

    formatDateRange(dateRange) {
        // const [startDateStr, endDateStr] = dateRange.split(' - ');
        // const startDate = new Date(startDateStr);
        // const endDate = new Date(endDateStr);
        // const startFormatted = format(startDate, "do 'of' MMM");
        // const endFormatted = format(endDate, "do 'of' MMM yyyy");
        // console.log('09099',startFormatted ,endFormatted)
        // return (
        //   <strong>
        //     {startFormatted} - {endFormatted}
        //   </strong>DoubleStoreyArea
        // DoubleStoreyAreaPercentage
        // );
    }

    // redirect to dashboard
    handleViewExhibition(data, data2) {
        console.log("exhibition data", data)
        sessionStorage.setItem("sessionExhibitionID", data.ExhibitionID)
        sessionStorage.setItem("exhibitionCode", data.Code)
        sessionStorage.setItem("sessionExhibitionName", data.ExhibitionName)
        sessionStorage.setItem("ExhibitionFromDateSS", data.FromDate)
        sessionStorage.setItem("ExhibitionToDateSS", data.ToDate)
        sessionStorage.setItem("ExhibitionAddressSS", data.Address)
        sessionStorage.setItem("ExhibitionLogoSS", data.Logo)
        sessionStorage.setItem("isDoubleStoreyExhibition", data.isDoubleStorey)
        sessionStorage.setItem("isSSIcertificateExhibition", data.isSSICertificate)
        sessionStorage.setItem("DoubleStoreyArea", data.DoubleStoreyArea)
        sessionStorage.setItem("DoubleStoreyAreaPercentage", data.DoubleStoreyAreaPercentage)
        var emailArr = data.ExhMailEmail != '' && data.ExhMailEmail != null ? data.ExhMailEmail.split(",") : []
        var mobileArr = data.ExhMailMobile != '' && data.ExhMailMobile != null ? data.ExhMailMobile.split(",") : []
        sessionStorage.setItem("sessionExhibitionEmail", JSON.stringify(emailArr))
        sessionStorage.setItem("sessionExhibitionMobileNo", JSON.stringify(mobileArr))
        sessionStorage.setItem("RulesAndRegulations", data.RulesAndRegulations)
        sessionStorage.setItem("ExhibitionName", data.ExhibitionName)
        const loginDataSS = JSON.parse(sessionStorage.getItem("loginDataSS"))
        loginDataSS.RoleID = data2.RoleID
        loginDataSS.RoleName = data2.roleName
        sessionStorage.setItem("loginDataSS", JSON.stringify(loginDataSS))
        sessionStorage.setItem("RoleIDSS", loginDataSS.RoleID)
        const roleId = loginDataSS.RoleID
        const roleName = loginDataSS.RoleName
        if (roleId == 1 && roleName == "Exhibitor") {
            this.props.navigate('/selectApplication')
        } else if (roleId == 8 && roleName == "Partner") {
            this.props.navigate('/selectApplication')
        } else if (roleId == 3 && roleName == "Visitor") {
            this.props.navigate('/visitordashboard')
        } else if ((roleId == 2 && roleName == "Admin") || (roleId == 5 && roleName == "Visitor Admin") ||
            (roleId == 6 && roleName == "Super Admin")) {
            this.props.navigate('/dashboard')
        } else if (roleId == 4 && roleName == "Agent") {
            this.props.navigate('/agentdashboard')
        } else if ((roleId == 7 && roleName == "Vendor") || (roleId == 17 && roleName == "Stall Design Architect")) {
            this.props.navigate('/VendorModule')
        } else if ((roleId == 16 && roleName == "Hall Manager") || (roleId == 20 && roleName == "Team Member")) {
            this.props.navigate('/onsiteManager')
        } else if ((roleId == 18 && roleName == "Gate Security") || (roleId == 19 && roleName == "Hall Security")) {
            this.props.navigate('/entryGate')
        }
        else if (roleId == 15 && roleName == "Delegate") {
            this.props.navigate('/delegateDashboard')
        } else if ((roleId == 25 && roleName == "Zone Manager")) {
            this.props.navigate('/onsiteManager')
        } else {
            this.props.navigate('/dashboard')
        }
    }

    render() {
        const { isLoading, isOpen, historyToggle, exhibitionDataList, pastList, nextList, isLoginAccess } = this.state
        return (
            <>

                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}

                <ToastContainer />
                <AdminHeader isSteper={true} />

                {/*/APP-SIDEBAR*/}

                <div className="choose-exhibition container main-area-start" style={{ position: 'relative' }}>
                    <div className="row g-0">

                        <div className="d-flex justify-content-end">
                            <span
                                className="p-2 py-1 px-3 mx-1 btn-aqua exb-name"
                                onClick={() => this.setState({ historyToggle: historyToggle == 0 ? 1 : 0 })}
                            >
                                {historyToggle == 0 ? 'Next exhibition' : 'Past Exhibition'}
                            </span>
                        </div>
                    </div>
                    {historyToggle == 0 ? <div className={`row ${pastList.length === 1 ? 'justify-content-center' : ''}`}>
                        {pastList.length > 0 && pastList.map(data => (
                            <>
                                {data.isExhibitionLive ?
                                    <div className="col-md-3 mb-4 px-3" >
                                        {console.log("data-->", data)}
                                        <div className="sel-app p-2 shadow-sm" style={{ border: "1px solid #e2e8f0", borderRadius: "8px" }}>
                                            <div className='align-all-site'>
                                                <img src={data.Logo} />
                                                <button className="btn btn-aqua date mt-3" type="submit">
                                                    <strong style={{ fontSize: '13px' }}>
                                                        {`${data.FromDate} - ${data.ToDate}`}
                                                        {/* { this.formatDateRange(`${data.FromDate} - ${data.ToDate}`)} */}
                                                    </strong>
                                                </button>
                                                <h3 className="loc mt-3" >
                                                    {data.Address}
                                                </h3>
                                                {data.isExhibitionClosed == 1 || isLoginAccess == 0 ? (
                                                    <a className='m-1'>
                                                        <button
                                                            type="button"
                                                            disabled={true}
                                                            className="btn btn-outline-dark mb-1 p-2"
                                                            style={{ width: "100%" }}
                                                        //  onClick={e => this.handleViewExhibition(data)}
                                                        >
                                                            Exhibition Closed
                                                        </button>
                                                    </a>
                                                ) : (
                                                    <>
                                                        <div className=''>
                                                            {data.accessList.length > 0 && data.accessList.map(data2 => (
                                                                <>
                                                                    {data2.isExhibitionAccess == 0 ? (null) : (
                                                                        <a className='m-1'>
                                                                            <button
                                                                                type="button"
                                                                                className="btn btn-outline-dark mb-1 p-2"
                                                                                style={{ width: "100%" }}
                                                                                onClick={e => this.handleViewExhibition(data, data2)}
                                                                            >
                                                                                {data2.RoleAccess}
                                                                            </button>
                                                                        </a>

                                                                    )}

                                                                </>
                                                            ))}
                                                        </div>
                                                    </>

                                                )}

                                            </div>
                                        </div>
                                    </div>
                                    :
                                    sessionStorage.getItem('isIndirectAccess') != 'false' ?
                                        <>
                                            <div className="col-md-3 mb-4 px-3">
                                                <div className="sel-app p-2 prod-bottom-issue h-100 shadow-sm" style={{ border: "1px solid #e2e8f0", borderRadius: "8px" }}>
                                                    <div className='align-all-site'>
                                                        <img src={data.Logo} />
                                                        <button className="btn btn-aqua date mt-3" type="submit">
                                                            <strong style={{ fontSize: '13px' }}>
                                                                {`${data.FromDate} - ${data.ToDate}`}
                                                                {/* { this.formatDateRange(`${data.FromDate} - ${data.ToDate}`)} */}
                                                            </strong>
                                                        </button>
                                                        <h3 className="loc mt-3" >
                                                            {data.Address}
                                                        </h3>
                                                        {data.isExhibitionClosed == 1 || isLoginAccess == 0 ? (
                                                            <a className='m-1'>
                                                                <button
                                                                    type="button"
                                                                    disabled={true}
                                                                    className="btn btn-outline-dark mb-1 p-2"
                                                                    style={{ width: "100%" }}
                                                                //  onClick={e => this.handleViewExhibition(data)}
                                                                >
                                                                    Exhibition Closed
                                                                </button>
                                                            </a>
                                                        ) : (
                                                            <>
                                                                <div className=''>
                                                                    {data.accessList.length > 0 && data.accessList.map(data2 => (
                                                                        <>
                                                                            {data2.isExhibitionAccess == 0 ? (null) : (

                                                                                <a className='m-1'>
                                                                                    <button
                                                                                        type="button"
                                                                                        className="btn btn-outline-dark mb-1 p-2"
                                                                                        style={{ width: "100%" }}
                                                                                        onClick={e => this.handleViewExhibition(data, data2)}
                                                                                    >
                                                                                        {data2.RoleAccess}
                                                                                    </button>
                                                                                </a>

                                                                            )}

                                                                        </>
                                                                    ))}
                                                                </div>
                                                            </>

                                                        )}

                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                        : <></>
                                }
                            </>
                        ))
                        }
                    </div> : <div className={`row ${nextList.length === 1 ? 'justify-content-center' : ''}`}>
                        {nextList.length > 0 && nextList.map(data => (
                            <>
                                {data.isExhibitionLive ?
                                    <div className="col-md-3 mb-4 px-3" >
                                        {console.log("data-->", data)}
                                        <div className="sel-app p-2 shadow-sm" style={{ border: "1px solid #e2e8f0", borderRadius: "8px" }}>
                                            <div className='align-all-site'>
                                                <img src={data.Logo} />
                                                <button className="btn btn-primary date mt-3" type="submit">
                                                    <strong style={{ fontSize: '13px' }}>
                                                        {`${data.FromDate} - ${data.ToDate}`}
                                                        {/* { this.formatDateRange(`${data.FromDate} - ${data.ToDate}`)} */}
                                                    </strong>
                                                </button>
                                                <h3 className="loc mt-3" >
                                                    {data.Address}
                                                </h3>
                                                {data.isExhibitionClosed == 1 || isLoginAccess == 0 ? (
                                                    <a className='m-1'>
                                                        <button
                                                            type="button"
                                                            disabled={true}
                                                            className="btn btn-outline-dark mb-1 p-2"
                                                            style={{ width: "100%" }}
                                                        //  onClick={e => this.handleViewExhibition(data)}
                                                        >
                                                            Exhibition Closed
                                                        </button>
                                                    </a>
                                                ) : (
                                                    <>
                                                        <div className=''>
                                                            {data.accessList.length > 0 && data.accessList.map(data2 => (
                                                                <>
                                                                    {data2.isExhibitionAccess == 0 ? (null) : (
                                                                        <a className='m-1'>
                                                                            <button
                                                                                type="button"
                                                                                className="btn btn-outline-dark mb-1 p-2"
                                                                                style={{ width: "100%" }}
                                                                                onClick={e => this.handleViewExhibition(data, data2)}
                                                                            >
                                                                                {data2.RoleAccess}
                                                                            </button>
                                                                        </a>

                                                                    )}

                                                                </>
                                                            ))}
                                                        </div>
                                                    </>

                                                )}

                                            </div>
                                        </div>
                                    </div>
                                    :
                                    sessionStorage.getItem('isIndirectAccess') != 'false' ?
                                        <>
                                            <div className="col-md-3 mb-4 px-3">
                                                <div className="sel-app p-2 prod-bottom-issue h-100 shadow-sm" style={{ border: "1px solid #e2e8f0", borderRadius: "8px" }}>
                                                    <div className='align-all-site'>
                                                        <img src={data.Logo} />
                                                        <button className="btn btn-primary date mt-3" type="submit">
                                                            <strong style={{ fontSize: '13px' }}>
                                                                {`${data.FromDate} - ${data.ToDate}`}
                                                                {/* { this.formatDateRange(`${data.FromDate} - ${data.ToDate}`)} */}
                                                            </strong>
                                                        </button>
                                                        <h3 className="loc mt-3" >
                                                            {data.Address}
                                                        </h3>
                                                        {data.isExhibitionClosed == 1 || isLoginAccess == 0 ? (
                                                            <a className='m-1'>
                                                                <button
                                                                    type="button"
                                                                    disabled={true}
                                                                    className="btn btn-outline-dark mb-1 p-2"
                                                                    style={{ width: "100%" }}
                                                                //  onClick={e => this.handleViewExhibition(data)}
                                                                >
                                                                    Exhibition Closed
                                                                </button>
                                                            </a>
                                                        ) : (
                                                            <>
                                                                <div className=''>
                                                                    {data.accessList.length > 0 && data.accessList.map(data2 => (
                                                                        <>
                                                                            {data2.isExhibitionAccess == 0 ? (null) : (

                                                                                <a className='m-1'>
                                                                                    <button
                                                                                        type="button"
                                                                                        className="btn btn-outline-dark mb-1 p-2"
                                                                                        style={{ width: "100%" }}
                                                                                        onClick={e => this.handleViewExhibition(data, data2)}
                                                                                    >
                                                                                        {data2.RoleAccess}
                                                                                    </button>
                                                                                </a>

                                                                            )}

                                                                        </>
                                                                    ))}
                                                                </div>
                                                            </>

                                                        )}

                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                        : <></>
                                }
                            </>
                        ))
                        }
                    </div>}
                </div>

                <Footerlogin />

            </>
        );
    }


}

export default withRouter(connect(null, { selectExhibition_action, fill_action })(SelectExhibition));
